import clsx from 'clsx';
import Image from 'next/image';
import { resolveImageAltText } from '@/lib/utils';

/**
 * `removeBottomPadding` is pretty specifically used for one purpose only: When
 * the next block is a `CartSummary`, this block drops its bottom padding so the
 * two blocks visually connect.
 */
export default function InfoBanner({ block, position, removeBottomPadding }) {
  const {
    uid,
    description,
    icon,

    // From color picker (safelisted in tailwind config)
    background_color = '#ffffff',
    banner_bg_color = '#0e3739',
    text_color = '#ffffff'
  } = block?.info_banner?.reference?.[0] ?? {};

  if (!uid || !description) {
    console.warn(`[InfoBanner] Missing required fields for uid: ${uid}`);
    return null;
  }

  // Insert mobile line breaks based on [MOBILE_BR] placeholder symbols
  const formattedDescription = description.replace(
    /\[MOBILE_BR\]/g,
    '<br class="sm:hidden" />'
  );

  return (
    <section
      id={`${uid}_${position}`}
      data-name="info-banner"
      className={clsx(
        'px-5 pt-10 lg:pt-15',
        removeBottomPadding ? 'pb-0' : 'pb-10 lg:pb-15',
        `bg-[${background_color}]`
      )}
    >
      <div
        className={clsx(
          // Matches CartSummary container (smaller than normal containers)
          'mx-auto flex max-w-266 items-center justify-center gap-3 rounded px-4 py-3 sm:px-10 sm:py-4',
          `bg-[${banner_bg_color}] text-[${text_color}]`
        )}
      >
        {icon && (
          <Image
            src={icon.url}
            alt={resolveImageAltText(icon)}
            width={icon.dimension?.width ?? 24}
            height={icon.dimension?.height ?? 24}
            sizes="24px"
            className="w-6"
          />
        )}
        <div
          className="body-r text-center"
          dangerouslySetInnerHTML={{ __html: formattedDescription }}
        />
      </div>
    </section>
  );
}
